import { optimizedAppearDataAttribute } from './data-id.mjs';

function getOptimisedAppearId(visualElement) {
    return visualElement.props[optimizedAppearDataAttribute];
}

export { getOptimisedAppearId };
//# sourceMappingURL=get-appear-id.mjs.map
